import { ERROR_SCREEN_NAME } from '../../constants/analytics';

import type { CommonAttributes } from './types';

type ErrorScreenViewedAnalyticsProps = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: Record<string, any>;
};

export const onErrorScreenViewed = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: ErrorScreenViewedAnalyticsProps) => {
	return {
		name: ERROR_SCREEN_NAME,
		attributes: {
			commonAttributes,
		},
		nonPrivacySafeAttributes,
	};
};
